export default __webpack_public_path__ + "static/media/classes.5596fbce.svg";